import { render, staticRenderFns } from "./merber.vue?vue&type=template&id=44ff29f6&scoped=true"
import script from "./merber.vue?vue&type=script&lang=js"
export * from "./merber.vue?vue&type=script&lang=js"
import style0 from "./merber.vue?vue&type=style&index=0&id=44ff29f6&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff29f6",
  null
  
)

export default component.exports